import { linkEventAnalytics, } from './globalAnalytics';
var tryToSendEvent = function (performSendingEvent) {
    try {
        performSendingEvent();
    }
    catch (e) {
        if (window.location.hostname !== 'localhost') {
        }
    }
};
export var sendViewEvent = function () {
    var viewEvent = {
        eventName: 'AccountSuccessCreationPopoverDisplayed',
        viewEventAnalytics: {
            legacy: {
                page__pagename: 'Account Successful Creation Page-Popover',
            },
            pageName: 'Account Successful Creation Page-Popover',
        },
    };
    tryToSendEvent(function () {
        window.analyticsService.sendViewEvent(viewEvent.eventName, viewEvent.viewEventAnalytics);
    });
};
export var sendLinkEvent = function (eventName, keyLinkEvent) {
    tryToSendEvent(function () {
        var linkEvent = {
            eventName: eventName,
            linkEventAnalytics: {
                legacy: {
                    page__pagename: 'Account Successful Creation Page-Popover',
                },
                pageName: 'Account Successful Creation Page-Popover',
            },
            linkContext: null,
        };
        if (keyLinkEvent) {
            Object.assign(linkEvent.linkEventAnalytics, linkEventAnalytics[keyLinkEvent]);
        }
        window.analyticsService.sendLinkEvent(linkEvent.eventName, linkEvent.linkEventAnalytics, linkEvent.linkContext);
    });
};
//# sourceMappingURL=analyticsService.js.map